import LegalLayout from "@/components/legal/legal-layout"
import content from "@/content/legal/privacidad.md?raw"

export default function Privacy() {
  return <LegalLayout title="Política de Privacidad" content={content} />
}
